import React from 'react';
import {Icon} from "semantic-ui-react";
import './style.css';
import {Col, Row} from "reactstrap";
import {Tooltip} from "antd";

class App extends React.Component {

  remove = () => {
    this.props.remove(this.props.index);
  }

  view = () => {
    window.open(this.props.blink);
  }

  render() {

    let name = this.props.name;
    if ((name).length > 12) {
      let slice = name.slice(0, 13) + "....";
      name = slice;
    } else {
      let number = 12 - (name).length;
    }

    return (
      <div>
        <Tooltip placement="topLeft" title={this.props.name}>
          <div className={"pdfHolder"}>
            <Row>
              <Col className={"paperPClip"} style={{marginLeft: "14px"}} xs={"1"} lg={"1"} md={"1"}>
                <Icon name='paperclip' style={{display: "inline"}}/>
              </Col>
              <Col className={"uploaderTextName"} xs={"5"} lg={"5"} md={"5"}>
                <div style={{display: "inline", wordWrap: "break-word"}}>
                  {
                    name
                  }
                </div>
              </Col>
              <Col className={"uploaderActionBtns"} xs={"5"} lg={"5"} md={"5"}>
                <div>
                  {
                    this.props.blink !== "" ?
                      <Icon
                        name='eye'
                        className={"uploadActionBtn viewBtn"} onClick={this.view}/>
                      : ""
                  }
                  <Icon
                    name='trash alternate'
                    className={"uploadActionBtn reUploadBtn"} onClick={this.remove}/>
                </div>
              </Col>
            </Row>
          </div>
        </Tooltip>
      </div>
    );
  }
}

export default App;
